<app-input
  *ngIf="userId"
  class="s-mt-3"
  [label]="'ID'"
  [formControlRef]="formControlRef().controls.id"
>
</app-input>
<app-input
  class="s-mt-3"
  [label]="'name' | transloco"
  [formControlRef]="formControlRef().controls.primeiroNomeusuario"
  [required]="true"
>
</app-input>
<app-input
  [label]="'CPF'"
  [formControlRef]="formControlRef().controls.cpfcnpj"
  [mask]="cpfMask"
  [required]="true"
>
</app-input>
<app-input
  *ngIf="!userId"
  [label]="'username' | transloco"
  [formControlRef]="formControlRef().controls.nomeUsuario"
  [required]="true"
>
</app-input>
<app-input
  [label]="'email' | transloco"
  [formControlRef]="formControlRef().controls.email"
  [email]="true"
  [required]="true"
>
</app-input>
<app-select
  [label]="'group' | transloco"
  [formControlRef]="formControlRef().controls.grupoUsuario"
  [items]="groupsList$ | async"
  [required]="true"
>
</app-select>
<app-input-password
  [label]="'password' | transloco"
  [formControlRef]="formControlRef().controls.senha"
>
</app-input-password>

<app-input-password
  [label]="'repeat-password' | transloco"
  [formControlRef]="formControlRef().controls.repeatPassword"
>
  <ng-container slot="hint">
    <span class="c-status-error" *ngIf="showMessageError">
      {{ "passwords-should-match" | transloco }}
    </span>
  </ng-container>
</app-input-password>
